import { useCenterStyles } from "./UseCenterStyles";
import { ICenterProps } from "./ICenterProps";

export function Center({ children, styleSet }: ICenterProps): JSX.Element {
  const styles = useCenterStyles(styleSet);

  return (
    <div className={styles.centerContainer}>
      <div className={styles.mainContainer}>{children}</div>
    </div>
  );
}
